function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { onlyDigits } from '@paperstac/helpers/lib/numberHelpers';
import React from 'react';
import Input from './Input';
const NumberInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    field,
    ...props
  } = _ref;
  const value = props.value || field.value;
  const name = props.name || field.name;
  const onChange = props.onChange || field.onChange;
  const handleChange = React.useCallback(_ref2 => {
    let {
      target: {
        value
      }
    } = _ref2;
    const digits = onlyDigits(value);
    onChange({
      target: {
        name,
        value: isNaN(digits) || digits === '' ? '' : +digits
      }
    });
  }, [name, onChange]);
  return /*#__PURE__*/React.createElement(Input, _extends({
    ref: ref
  }, field, props, {
    value: value,
    onChange: handleChange,
    inputMode: "numeric"
  }));
});
NumberInput.propTypes = {};
NumberInput.defaultProps = {};
NumberInput.displayName = 'NumberInput';
export default NumberInput;